import React from 'react';
import { Flex } from '@withjoy/joykit';
import { Box } from '@withjoy/joykit';
import { SearchParamsObserver } from '@apps/stays/components/SearchParamsObserver';
import { LocationDatesOccupants } from '@shared/components/LocationDatesOccupantsSearchBar/LocationDatesOccupantsSearchBar';
import { SearchParamsValue } from '@apps/stays/components/SearchParamsObserver/SearchParamsObserver';
import { StaysSearchTerms } from '@apps/stays/types';
import { AccommodationsConsoleState } from '@apps/accommodations/AccommodationsConsole.types';

export const AccommodationsConsoleHeader = ({
  eventName,
  handleSearchSubmit,
  handleFormSubmit,
  state
}: {
  eventName: string;
  handleSearchSubmit: (value: SearchParamsValue) => void;
  handleFormSubmit: (value: StaysSearchTerms) => void;
  state: AccommodationsConsoleState;
}) => {
  const searchFormInitialValue = {
    destination: state.searchLocation,
    lat: state.circularRegionSearch.latitude,
    lng: state.circularRegionSearch.longitude,
    startDate: {
      year: parseInt(state.searchDates.start.split('-')[0]),
      month: parseInt(state.searchDates.start.split('-')[1]),
      day: parseInt(state.searchDates.start.split('-')[2])
    },
    endDate: {
      year: parseInt(state.searchDates.end.split('-')[0]),
      month: parseInt(state.searchDates.end.split('-')[1]),
      day: parseInt(state.searchDates.end.split('-')[2])
    },
    rooms:
      state.occupancies?.occupancies?.map(occ => ({
        adults: occ.adults,
        childrenAges: (occ.childrenAges || []).filter((age): age is number => age !== null)
      })) || []
  };

  return (
    <>
      <SearchParamsObserver onValueUpdate={handleSearchSubmit} />
      {/* Header Section */}
      <Flex alignItems="center" gap={4} padding={4} borderBottom="1px solid" background="white" position="sticky" top={0} zIndex={1000} borderColor="mono3">
        <Box flex={1}>
          <LocationDatesOccupants onSubmit={handleFormSubmit} initialValue={searchFormInitialValue} />
        </Box>
      </Flex>
    </>
  );
};
